import { IndexedObject } from 'constants/types';
import {
  DATA_TYPE_CALCULATED_ANSWER,
  DATA_TYPE_CALCULATED_CORRECT_ANSWER,
  DATA_TYPE_STUDENT_ANSWER,
  getCtrlDataLabel,
} from 'constants/common';

export const DATA_SELECT_USER = [
  {
    value: 'M1',
    label: '天窓　換気温度',
  },
  {
    value: 'M2',
    label: '天窓　換気開度',
  },
  {
    value: 'M3',
    label: '重油炊き暖房温度',
  },
  {
    value: 'M4',
    label: '湿度管理 目標湿度',
  },
  {
    value: 'M5',
    label: '保温カーテン　保温温度',
  },
  {
    value: 'M6',
    label: '保温カーテン　保温感度',
  },
  {
    value: 'M7',
    label: 'CO2濃度設定',
  },
  {
    value: 'M8',
    label: '循環扇　タイマー',
  },
  {
    value: 'M9',
    label: 'かん水 1株あたりの1日かん水量',
  },
];
export const DATA_SELECT_SIMULATION = [
  {
    value: 'C1',
    label: '温度',
  },
  {
    value: 'C2',
    label: '湿度',
  },
  {
    value: 'C3',
    label: 'CO2濃度',
  },
];

export const getChartConfig = (data: any, unanswered: string[]) => ({
  data,
  xField: 'Date',
  yField: 'scales',
  appendPadding: 0,
  seriesField: 'type',
  legend: false,
  color: (type: IndexedObject) => {
    // 回答した制御設定に基づく環境シミュレーション結果
    if (type.type === DATA_TYPE_CALCULATED_ANSWER) return 'blue';
    // 模範の環境シミュレーション結果
    if (type.type === DATA_TYPE_CALCULATED_CORRECT_ANSWER) return 'red';
    // 回答した制御設定
    if (type.type === DATA_TYPE_STUDENT_ANSWER) return 'blue';
    return 'gray';
  },
  lineStyle: (type: IndexedObject) => {
    // 回答した制御設定に基づく環境シミュレーション結果、模範の環境シミュレーション結果
    if (type.type === DATA_TYPE_CALCULATED_ANSWER || type.type === DATA_TYPE_CALCULATED_CORRECT_ANSWER) {
      return {
        lineDash: [4, 4], // 点線にする
        opacity: 0.8,
      };
    }
    return {};
  },
  xAxis: {
    tickCount: 28,
    label: {
      style: (month: string) => {
        if (unanswered.some((item) => item === month)) {
          return {
            fill: 'red',
            fontSize: 16,
            fontWeight: 500,
            textAlign: 'center',
          };
        }
        return {
          fontSize: 16,
          fontWeight: 500,
          textAlign: 'center',
        };
      },
    },
  },

  slider: {
    start: 0,
    end: 1,
  },
  point: {
    shape: 'breath-point-u8-3',
  },
  tooltip: {
    formatter: (datum: any) => ({
      name: getCtrlDataLabel(datum.type),
      value: datum.scales,
    }),
  },
});
